import { Tabs, type TabsTabProps } from "@mantine/core";
import { useMatch, useNavigate, useResolvedPath } from "react-router";
import type { Delivery } from "../../../../../utils/backend-types";
import { buildFieldNameToLabelMap } from "../../../../../utils/react-hook-form/buildFieldNameToLabelMap";
import { HistoryTab } from "../../../../HistoryTab/HistoryTab";
import type { DeliveryFormProps } from "../DeliveryForm/DeliveryForm";
import { DeliveryForm } from "../DeliveryForm/DeliveryForm";
import { DELIVERY_FORM_FIELD_DATA } from "../DeliveryForm/DeliveryForm.constants";

type TabProps = TabsTabProps & { label: string };

const DELIVERY_TABS = {
  TAB_GENERAL: "allgemein",
  TAB_HISTORY: "historie"
};

const TABS: Array<TabProps> = [
  {
    value: DELIVERY_TABS.TAB_GENERAL,
    label: "Allgemein"
  },
  {
    value: DELIVERY_TABS.TAB_HISTORY,
    label: "Historie"
  }
];

interface EditFormProps extends DeliveryFormProps {
  delivery: Delivery;
}

function EditForm({
  buttonContainer,
  delivery,
  options,
  onCancel,
  onSubmit,
  missingFields,
  shouldFieldBeHighlighted
}: EditFormProps) {
  const navigate = useNavigate();
  const resolved = useResolvedPath(":activeTab");
  const match = useMatch({ path: resolved.pathname, end: true });
  const activeTab = match?.params.activeTab ?? DELIVERY_TABS.TAB_GENERAL;
  const fieldNameToLabelMap = buildFieldNameToLabelMap<Delivery>(
    DELIVERY_FORM_FIELD_DATA
  );

  return (
    <Tabs
      className="EditForm"
      value={activeTab}
      onChange={(newTab) => navigate(`./${newTab}`)}
    >
      <Tabs.List>
        {TABS.map((tab) => (
          <Tabs.Tab component="a" key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      <Tabs.Panel value={DELIVERY_TABS.TAB_GENERAL}>
        <DeliveryForm
          buttonContainer={buttonContainer}
          delivery={delivery}
          missingFields={missingFields}
          options={options}
          shouldFieldBeHighlighted={shouldFieldBeHighlighted}
          onCancel={onCancel}
          onSubmit={onSubmit}
        />
      </Tabs.Panel>
      <Tabs.Panel value={DELIVERY_TABS.TAB_HISTORY}>
        <HistoryTab
          entityId={delivery.id}
          entityType={"delivery"}
          fieldNameToLabelMap={fieldNameToLabelMap}
        />
      </Tabs.Panel>
    </Tabs>
  );
}

export { EditForm, EditFormProps };
